// Varenza auto-size fix v5 (2026-10-31): event-bubbling independent.
// Uses MutationObserver + continuous polling, listeners attached directly to pickers.
(function () {
  if (window.__varenzaAutoSize5) return;
  window.__varenzaAutoSize5 = true;
  function findSizeInputs(picker) {
    var fieldsets = picker.querySelectorAll('fieldset');
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      var t = legend ? legend.textContent.trim().toLowerCase() : '';
      if (t.indexOf('size') === 0) return fieldsets[i].querySelectorAll('input[type="radio"]');
    }
    var byAttr = picker.querySelectorAll('input[type="radio"][data-option-name="Size"]');
    if (byAttr.length) return byAttr;
    if (fieldsets.length >= 2) return fieldsets[1].querySelectorAll('input[type="radio"]');
    return picker.querySelectorAll('input[type="radio"]');
  }
  function isUsable(r) {
    if (r.disabled) return false;
    if (r.getAttribute('aria-disabled') === 'true') return false;
    var label = r.closest ? r.closest('label') : null;
    if (label && (label.classList.contains('disabled') || label.getAttribute('aria-disabled') === 'true')) return false;
    return true;
  }
  function autoSelect(picker) {
    if (!picker) return;
    var inputs = findSizeInputs(picker);
    if (!inputs.length) return;
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].checked && isUsable(inputs[i])) return;
    }
    for (var j = 0; j < inputs.length; j++) {
      if (isUsable(inputs[j])) {
        inputs[j].click();
        if (!inputs[j].checked) {
          inputs[j].checked = true;
          inputs[j].dispatchEvent(new Event('change', { bubbles: true }));
          inputs[j].dispatchEvent(new Event('click', { bubbles: true }));
        }
        return;
      }
    }
  }
  function allPickers() {
    var list = document.querySelectorAll('variant-picker');
    return list.length ? list : [document.body];
  }
  function runAll() {
    var ps = allPickers();
    for (var i = 0; i < ps.length; i++) autoSelect(ps[i]);
  }
  function attach() {
    var ps = document.querySelectorAll('variant-picker');
    for (var i = 0; i < ps.length; i++) {
      (function (p) {
        p.addEventListener('click', function () { setTimeout(function () { autoSelect(p); }, 100); setTimeout(function () { autoSelect(p); }, 500); });
        p.addEventListener('change', function () { setTimeout(function () { autoSelect(p); }, 100); setTimeout(function () { autoSelect(p); }, 500); });
        if (window.MutationObserver) {
          var obs = new MutationObserver(function () { setTimeout(function () { autoSelect(p); }, 100); setTimeout(function () { autoSelect(p); }, 500); });
          obs.observe(p, { childList: true, subtree: true, attributes: true });
        }
      })(ps[i]);
    }
  }
  attach();
  var n = 0;
  var poll = setInterval(function () {
    n++;
    runAll(); sortAll();
    if (n > 120) clearInterval(poll);
  }, 500);

  // --- Size order fix (2026-10-31): Shopify values order puts X-Small last
  // after the Item reorder, so sort the visible Size buttons in the picker.
  function sizeRank(val) {
    var v = (val || '').trim();
    if (v === 'X-Small') return 0;
    if (v === 'Small') return 1;
    if (v === 'Medium') return 2;
    if (v === 'Large') return 3;
    if (v === 'X-Large') return 4;
    if (v === 'XX-Large') return 5;
    if (v === 'One Size') return 6;
    var n = parseFloat(v);
    if (!isNaN(n)) return 10 + n;
    return 99;
  }
  function sortSizeButtons(picker) {
    if (!picker || !picker.querySelectorAll) return;
    var fieldsets = picker.querySelectorAll('fieldset');
    var fs = null;
    for (var i = 0; i < fieldsets.length; i++) {
      var legend = fieldsets[i].querySelector('legend');
      var t = legend ? legend.textContent.trim().toLowerCase() : '';
      if (t.indexOf('size') === 0) { fs = fieldsets[i]; break; }
    }
    if (!fs && fieldsets.length >= 2) fs = fieldsets[1];
    if (!fs) return;
    var labels = Array.prototype.slice.call(fs.querySelectorAll('label'));
    if (labels.length < 2) return;
    labels.sort(function (a, b) {
      var ia = a.querySelector('input[type="radio"]');
      var ib = b.querySelector('input[type="radio"]');
      var va = ia ? ia.value : a.textContent.trim();
      var vb = ib ? ib.value : b.textContent.trim();
      return sizeRank(va) - sizeRank(vb);
    });
    for (var j = 0; j < labels.length; j++) fs.appendChild(labels[j]);
  }
  function sortAll() {
    var ps = document.querySelectorAll('variant-picker');
    for (var i = 0; i < ps.length; i++) sortSizeButtons(ps[i]);
  }
  // --- Hero first on clean links (2026-10-31): store links have no ?variant=,
  // so show the complete-look hero first instead of the default variant picture.
  var userInteracted = false;
  document.addEventListener('click', function (e) {
    var p = e.target && e.target.closest ? e.target.closest('variant-picker') : null;
    if (p) userInteracted = true;
  }, true);
  function showHeroFirst() {
    if (userInteracted) return;
    if (window.location.search.indexOf('variant=') !== -1) return;
    var imgs = document.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      var alt = (img.getAttribute('alt') || '').toLowerCase();
      if (alt.indexOf('hero') === -1) continue;
      if (img.clientWidth >= 200) continue;
      var btn = img.closest ? img.closest('button') : null;
      if (btn) { btn.click(); return; }
    }
    // Fallback (2026-11-01, v9): Look 2/3 hero media has EMPTY alt (create-product
    // drops image alt), so alt-matching never fires. Do NOT click the first
    // thumbnail (v7 failed live: gallery order is not media order, first
    // thumbnail was the coat). Instead read the product JSON (featured_image
    // = hero by construction) and click the thumbnail whose src contains the
    // hero filename, wherever it sits in the strip.
    if (window.location.pathname.indexOf('complete-look') === -1) return;
    var handle = window.location.pathname.replace(/^.*\/products\//, '').split('?')[0];
    fetch('/products/' + handle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (userInteracted) return;
        // NOTE (2026-11-01, v8 bug): in the .js product JSON, featured_image
        // is a plain URL STRING, not an object -- v8 read .src (undefined) and
        // silently exited. Handle string, object, and images[0] forms.
        var feat = '';
        if (data) {
          if (typeof data.featured_image === 'string') feat = data.featured_image;
          else if (data.featured_image && data.featured_image.src) feat = data.featured_image.src;
          else if (data.images && data.images.length) feat = data.images[0];
        }
        if (!feat) return;
        var fname = feat.split('/').pop().split('?')[0];
        if (!fname) return;
        var timgs = document.querySelectorAll('img');
        for (var k = 0; k < timgs.length; k++) {
          var timg = timgs[k];
          if ((timg.src || '').indexOf(fname) === -1) continue;
          if (timg.clientWidth >= 200) continue;
          var tbtn = timg.closest ? timg.closest('button') : null;
          if (tbtn) { tbtn.click(); return; }
        }
      })
      .catch(function () {});
  }
  // v10 (2026-11-01): hero switch jaldi chahiye -- script body ke end par hai,
  // is liye gallery thumbnails DOM me maujood hain. Foran run karo + chhote
  // retries, taake gallery JS ready hote hi switch ho jaye (pehle 800/2000ms tha).
  showHeroFirst();
  setTimeout(showHeroFirst, 200);
  setTimeout(showHeroFirst, 500);
  setTimeout(showHeroFirst, 1000);
  setTimeout(sortAll, 800);
  setTimeout(sortAll, 2000);
  var _origRunAll = null;
})();
